/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-require-imports */
import React from 'react';
import {ProductList} from '../ProductList/ProductList';
import {IGallerySantaProps, IPropsInjectedByViewerScript, LoadMoreType} from '../../../types/galleryTypes';
import s from './GalleryApp.scss';
import classNames from 'classnames';

import {Omit} from '@wix/native-components-infra/dist/es/src/types/types';
import autobind from 'auto-bind-es5';
import {Announcer} from '@wix/wixstores-client-core/dist/es/src/a11y/announcer';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withGlobals} from '../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../galleryGlobalStrategy';
import {inlineStyleFix} from '../../../styles/inlineStyle';
import 'wicg-inert';
import {SideFilters} from '../../../common/components/SideFilters/SideFilters';
import {Sort} from '../../../common/components/Sort/Sort';
import {MobileFiltersAndSort} from '../../../common/components/MobileFiltersAndSort/MobileFiltersAndSort';
import {shouldShowGalleryAppInLayout} from './appUtils';
import {SlotsPlaceholder, withRepeatedSlotsPlaceholders} from '@wix/widget-plugins-ooi';
import {Experiments, GallerySlotIds} from '../../../constants';
import {ConditionalRender} from '../../../common/components/ConditionalRender/ConditionalRender';
import {renderSuggestedCurrencyAutoSwitchToastOnce} from '@wix/wixstores-client-storefront-common';

export enum DataHook {
  Root = 'gallery-app-root',
  Content = 'gallery-app-content',
  Container = 'gallery-app-container',
  SideFiltersContainer = 'gallery-side-filters-container',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  SideFilters = 'gallery-aside-filters',
  MobileContainer = 'mobile-container',
}

export type IGalleryAppProps = Omit<IPropsInjectedByViewerScript & IGallerySantaProps, IGalleryGlobalProps['globals']> &
  IGalleryGlobalProps &
  IProvidedTranslationProps;

class GalleryAppComp extends React.Component<IGalleryAppProps> {
  private a11yAnnouncer: Announcer;
  private renderedSuggestedCurrencyToastIntentId?: string;

  constructor(props) {
    super(props);
    this.state = {
      isSSR: props.isSSR,
    };
    autobind(this);
  }

  public componentDidMount() {
    this.renderSuggestedCurrencyAutoSwitchToast();
    this.scrollToProductIfReturnedFromProductPage();
    this.a11yAnnouncer = new Announcer('gallery-announcer');
    this.props.host.registerToComponentDidLayout(this.reportAppLoaded);
    const shouldWaitForLoadedRender = this.props.globals.useExperiments.enabled(
      Experiments.FixGalleryLoadedPanoramaTransactionSymmetry
    );
    if (this.props.globals.isInteractive && (!shouldWaitForLoadedRender || this.props.isLoaded)) {
      this.props.globals.reportWidgetLoadedPanorama();
    }
  }

  public componentDidUpdate(prevProps: Readonly<IGalleryAppProps>) {
    if (
      this.props.globals.isInteractive &&
      this.props.globals.useExperiments.enabled(Experiments.FixGalleryLoadedPanoramaTransactionSymmetry) &&
      !prevProps.isLoaded &&
      this.props.isLoaded
    ) {
      this.props.globals.reportWidgetLoadedPanorama();
    }

    const didBecomeInteractive = !prevProps.globals.isInteractive && this.props.globals.isInteractive;
    const didSuggestedCurrencyAutoSwitchToastIntentChange =
      prevProps.suggestedCurrencyAutoSwitchToastIntent?.id !== this.props.suggestedCurrencyAutoSwitchToastIntent?.id;

    if (didBecomeInteractive || didSuggestedCurrencyAutoSwitchToastIntentChange) {
      this.renderSuggestedCurrencyAutoSwitchToast();
    }

    const useFiltersAnnouncer = this.props.globals.useFiltersAnnouncer;
    if (
      useFiltersAnnouncer?.shouldAnnounceFilters &&
      prevProps.globals.useFiltersAnnouncer.shouldAnnounceFilters !== useFiltersAnnouncer.shouldAnnounceFilters
    ) {
      this.a11yAnnouncer.announce(
        this.props.t('announceFiltersUpdate', {
          numberOfFoundProducts: this.props.globals.products && this.props.globals.products.length,
        })
      );
      useFiltersAnnouncer.setShouldAnnounceFilters(false);
    }
  }

  public componentWillUnmount() {
    this.a11yAnnouncer.cleanup();
  }

  private renderSuggestedCurrencyAutoSwitchToast() {
    if (!this.props.globals.isInteractive) {
      return;
    }

    this.renderedSuggestedCurrencyToastIntentId = renderSuggestedCurrencyAutoSwitchToastOnce(
      this.props.suggestedCurrencyAutoSwitchToastIntent,
      this.renderedSuggestedCurrencyToastIntentId
    );
  }

  private readonly updateStateForScrollRestorationAndClearQueryParams = () => {
    // Thunderbolt's way to remove query params calls `locationSdkProvider.ts` which calls `history.replaceState` with `null`.
    // `scrollRestorationApi.ts` happens on loading of page and reads `history.state` which now is `null`. So it's logic is to scroll to top.
    // Fix: remove the query params natively, and call `history.replaceState` with the correct `scrollY` position.
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.delete('scrollToProduct');
    window.history.replaceState({scrollY: window.scrollY}, '', urlObj.toString());
  };

  private scrollToProductIfReturnedFromProductPage() {
    const {
      globals: {scrollToProduct},
    } = this.props;

    if (scrollToProduct) {
      setTimeout(() => {
        const productItem = document.querySelector(`[data-hook="${DataHook.Root}"] [data-slug="${scrollToProduct}"]`);
        if (productItem) {
          productItem.scrollIntoView({block: 'center'});
          this.updateStateForScrollRestorationAndClearQueryParams();
        }
      }, 100);
    }
  }

  private reportAppLoaded() {
    if (this.props.globals.isInteractive && typeof this.props.onAppLoaded === 'function') {
      this.props.onAppLoaded();
    }
  }

  private shouldAddLoadMoreBuffer() {
    const {
      globals: {isLiveSiteMode},
    } = this.props;
    const shouldShowWhenInfiniteScroll =
      this.props.globals.loadMoreType === LoadMoreType.INFINITE &&
      this.props.globals.hasMoreProductsToLoad &&
      !this.props.globals.isSSR;
    return isLiveSiteMode && (this.props.globals.productsRequestInProgress || shouldShowWhenInfiniteScroll);
  }

  public render() {
    const shouldRenderEmptyStateForDeletedCollection = this.props.globals.useExperiments.enabled(
      Experiments.GalleryEmptyStateForDeletedCollection
    );
    const shouldRender = shouldRenderEmptyStateForDeletedCollection
      ? this.props.isLoaded
      : shouldShowGalleryAppInLayout(this.props.isLoaded, this.props.globals);

    if (!shouldRender) {
      return null;
    }

    const {
      hasSelectedFilters,
      styles,
      stylesParams,
      hasFilters,
      shouldShowMobile,
      hasActiveSortOption,
      isCategoryVisible,
      experiments: {shouldRenderSlotsInGallery},
      isMobileOnDesktopMode,
    } = this.props.globals;
    const isFullWidth = styles.get(stylesParams.full_width);
    const responsive = styles.get(stylesParams.responsive);

    const isDesktop = !shouldShowMobile;
    const shouldRenderSideFilters = isDesktop && hasFilters && isCategoryVisible;
    const shouldRenderDesktopSort = isDesktop && hasActiveSortOption && isCategoryVisible;
    const shouldRenderMobileFiltersAndSort = shouldShowMobile && isCategoryVisible;

    const shouldHaveStickySidebar = styles.get(stylesParams.gallery_enableStickySidebar);
    const shouldAddLoadMoreBuffer = this.shouldAddLoadMoreBuffer();

    const classnames = {
      app: classNames(s.galleryApp, s.dynamicPadding, {
        deviceMobile: shouldShowMobile,
        notCssPerBreakpoint: !this.props.host.usesCssPerBreakpoint,
        isMobileOnDesktopMode,
      }),
      content: classNames(s.content, s.responsiveWidth, {
        [s.contentResponsive]: responsive,
        [s.fullWidth]: isFullWidth,
      }),
      container: classNames(s.container, s.dynamicPadding, {
        [s.galleryContentWidth]: isDesktop && shouldRenderSideFilters,
        [s.loadMoreBuffer]: shouldAddLoadMoreBuffer,
      }),
      sideFiltersContainer: classNames(s.filtersContainerWidth, {
        [s.sideFiltersWithSort]: hasActiveSortOption,
        [s.stickySidebar]: shouldHaveStickySidebar,
        [s.sideFiltersNoShrink]: this.props.globals.useExperiments.enabled(Experiments.GalleryFixSideFiltersShrink),
      }),
    };

    const isPluginInstalledInGalleryProductsTopSlot = !!this.props.globals.slots?.[GallerySlotIds.GalleryProductsTop];
    const isPluginInstalledInGalleryProductsBottomSlot =
      !!this.props.globals.slots?.[GallerySlotIds.GalleryProductsBottom];

    return (
      <>
        <style dangerouslySetInnerHTML={{__html: inlineStyleFix}} />
        <div data-hook={DataHook.Root} data-is-responsive={responsive} className={classnames.app}>
          <div data-hook={DataHook.Content} className={classnames.content}>
            {shouldRenderSideFilters && (
              <ConditionalRender
                by="galleryShowFilters"
                dataHook={DataHook.SideFiltersContainer}
                className={classnames.sideFiltersContainer}>
                <SideFilters {...this.props.globals} />
              </ConditionalRender>
            )}
            <div data-hook={DataHook.Container} className={classnames.container}>
              {shouldRenderDesktopSort && (
                <ConditionalRender by="galleryShowSort">
                  <Sort />
                </ConditionalRender>
              )}
              {shouldRenderMobileFiltersAndSort && <MobileFiltersAndSort {...this.props.globals} />}
              {shouldRenderSlotsInGallery && (
                <div className={classNames({[s.galleryProductsTopSlot]: isPluginInstalledInGalleryProductsTopSlot})}>
                  <SlotsPlaceholder slotId={GallerySlotIds.GalleryProductsTop} />
                </div>
              )}
              {<ProductList hasFilters={hasSelectedFilters} />}
              {shouldRenderSlotsInGallery && (
                <div
                  className={classNames({[s.galleryProductsBottomSlot]: isPluginInstalledInGalleryProductsBottomSlot})}>
                  <SlotsPlaceholder slotId={GallerySlotIds.GalleryProductsBottom} />
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export const GalleryApp = withRepeatedSlotsPlaceholders(withGlobals(withTranslations()(GalleryAppComp)));
